import {Types} from 'mongoose';
import {GenderTypes} from '@/enums/GenderTypes.enum';
import {Responsible} from '@/interfaces/responsible.interface';
import {ResponsibleHandlerAPI} from '@/classes/api/responsible-handler.api.class';
import {retrieveObjectId} from '@/helpers/isObjectId.helper';
import {ContactFormValue, contactFormFromEntity, emptyContactForm} from '@/helpers/contactInformationForm.helper';

/** Plain form state of a responsible (v-model of responsibleForm.vue) */
export interface ResponsibleFormValue {
    gender: GenderTypes | null;
    firstName: string;
    lastName: string;
    birthday: Date | null;
    jobType: Types.ObjectId | null;
    contactInformation: ContactFormValue;
}

/** Which field groups are shown (hidden = no read and update access). All true by default. */
export interface ResponsibleFormPermissions {
    gender: boolean;
    firstName: boolean;
    lastName: boolean;
    birthday: boolean;
    jobType: boolean;
    contactInformation: boolean;
    /** Shows "Neue Jobposition anlegen" (createJobTypeDialog) */
    createJobType: boolean;
}

export type JobTypeItem = { text: string; value: Types.ObjectId };

export const FULL_RESPONSIBLE_FORM_PERMISSIONS: ResponsibleFormPermissions = {
    gender: true,
    firstName: true,
    lastName: true,
    birthday: true,
    jobType: true,
    contactInformation: true,
    createJobType: false,
};

export function emptyResponsibleForm(): ResponsibleFormValue {
    return {
        gender: null,
        firstName: '',
        lastName: '',
        birthday: null,
        jobType: null,
        contactInformation: emptyContactForm(),
    };
}

export function responsibleFormFromEntity(responsible: Responsible): ResponsibleFormValue {
    return {
        gender: responsible.gender ?? null,
        firstName: responsible.firstName || '',
        lastName: responsible.lastName || '',
        birthday: responsible.birthday || null,
        jobType: (retrieveObjectId(responsible.jobType) as Types.ObjectId | undefined) || null,
        contactInformation: contactFormFromEntity(responsible.contactInformation),
    };
}

/** Loads all job types as autocomplete items (same request as the former jobTypeAutocomplete) */
export async function loadJobTypeItems(): Promise<JobTypeItem[]> {
    const resp = await ResponsibleHandlerAPI.jobTypes.find({skipPagination: true});
    return resp.jobTypes.map((jobType) => ({text: jobType.neutral, value: jobType._id}));
}
